import { ILatLng, Polygon } from '@ionic-native/google-maps';

type OnClickFunction = (point: ILatLng, polygon: Polygon) => void;

export interface PolygonOptions {
	clickable ? : boolean;
	onclick ? : OnClickFunction;
	contentTooltip ? : string;
	borderColor ? : string;
	fillColor ? : string;
}